import { Route } from '@angular/router';
import { ValidateComponent } from './validate.component';

export const ValidateRoutes: Route[] = [
  {
    path: 'dogrula',
    component: ValidateComponent
  },
  {
    path: 'd/:code',
    component: ValidateComponent
  }
];
